import { render, staticRenderFns } from "./productDescDia.vue?vue&type=template&id=7349b4b4&scoped=true"
import script from "./productDescDia.vue?vue&type=script&lang=js"
export * from "./productDescDia.vue?vue&type=script&lang=js"
import style0 from "./productDescDia.vue?vue&type=style&index=0&id=7349b4b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349b4b4",
  null
  
)

export default component.exports